import { Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import React from 'react';

import { L2DErrorImage } from '@europrocurement/flexy-components';
import NoResult from '../../../../Dossiers/components/detail/NoResult/NoResult';
import { L2DPLogoIcon } from '../L2DPLogoIcon/L2DPLogoIcon';
import { L2DRLogoIcon } from '../L2DRLogoIcon/L2DRLogoIcon';

export type PanierErrorLienProps = {
    env: string;
    error: 'traitement' | 'indisponible';
    type?: 'recouvrement' | 'paiement';
};

const PanierErrorLien: React.FunctionComponent<PanierErrorLienProps> = function ({
    env,
    error,
    type = 'paiement',
}) {
    return (
        <Container>
            {env !== 'prod' ? (
                <Box
                    id="env-ribbon"
                    className={`${env}`}
                >
                    {env}
                </Box>
            ) : null}
            <Box sx={{ textAlign: 'center' }}>
                {type === 'paiement' ? <L2DPLogoIcon /> : <L2DRLogoIcon />}
            </Box>
            {error === 'traitement' ? (
                <Box
                    sx={{
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                    }}
                >
                    <L2DErrorImage />

                    <Box
                        sx={{
                            width: '50%',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                        }}
                    >
                        <Typography
                            variant="l2dlabel"
                            sx={{ color: 'text.gris70' }}
                        >
                            Une erreur est survenue lors du traitement de votre demande.
                        </Typography>
                        <Typography
                            variant="l2dlabel"
                            sx={{ color: 'text.gris70' }}
                        >
                            Il se peut que le service de paiement soit temporairement indisponible.
                        </Typography>
                        <Typography
                            variant="l2dlabel"
                            sx={{ color: 'text.gris70' }}
                        >
                            Veuillez patienter quelques instants avant de réessayer.
                        </Typography>
                        <Typography
                            variant="l2dlabel"
                            sx={{ color: 'text.gris70' }}
                        >
                            Si le problème persiste, nous vous invitons à contacter notre service
                            d’assistance.
                        </Typography>
                    </Box>
                </Box>
            ) : (
                <NoResult
                    paddingSx="80px"
                    title="Aucun paiement disponible pour le moment"
                />
            )}
        </Container>
    );
};

export default PanierErrorLien;
